import { render, staticRenderFns } from "./SidebarSummary.vue?vue&type=template&id=f82ed8de&"
import script from "./SidebarSummary.vue?vue&type=script&lang=js&"
export * from "./SidebarSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports